import React from 'react';
import PropTypes from 'prop-types';
import CountryModel from 'src/common/models/l10n/CountryModel';
import FooterLinkModel from 'src/common/models/prismic/components/FooterLinkModel';

import './Linkset.scss';

const LinkSet = props => (
  <nav className="footer-links">
    <ul>
      {props.linkItems.map(item => (
        <li key={item.url}>
          <a
            href={item.url}
            className="footer-link"
            target={item.openInNewTab ? '_blank' : null}
            rel={!item.googleFollow ? 'nofollow noopener' : null}
            onClick={props.onTrackLink({
              category: 'Footer Navigation',
              action: props.linkSet.title,
              label: item.linkText,
              href: item.url,
            })}>
            <span className="footer-link-text">
              {item.linkText}
              {item.label && <span className="footer-link-label">{item.label}</span>}
            </span>
          </a>
        </li>
      ))}
    </ul>
  </nav>
);

LinkSet.propTypes = {
  linkSet: PropTypes.shape({
    title: PropTypes.string.isRequired,
  }).isRequired,
  linkItems: PropTypes.arrayOf(FooterLinkModel.propTypes).isRequired,
  country: CountryModel.propTypes.isRequired,
  onTrackLink: PropTypes.func.isRequired,
};

export default LinkSet;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Footer/LinkSet/LinkSet.js